import { useCallback, useRef, useState } from "react";

export function useDisableTimerHook(key, durationSeconds = 60) {
    const timeoutRef = useRef(null);
    const storageKey = `disabled_until_${key}`;
    const getUntil = () => Number(localStorage.getItem(storageKey) || 0);

    const [until, setUntil] = useState(getUntil());

    const start = useCallback(
        (seconds = durationSeconds) => {
            const next = Date.now() + seconds * 1000;
            localStorage.setItem(storageKey, next);
            setUntil(next);
        },
        [storageKey]
    );

    const remaining = Math.max(
        0,
        Math.ceil((until - Date.now()) / 1000)
    );

    return {
        disabled: remaining > 0,
        remaining,
        start,
    };
}
